import { AlertTriangle, BadgePercent, Package, Radio, Truck } from "lucide-react";

const featureItems = [
  { label: "Distributors", icon: Package, description: "Track loads and inventory in one place." },
  { label: "Drivers", icon: Truck, description: "Run live GPS and delivery workflows." },
  { label: "Dispatchers", icon: Radio, description: "Coordinate routes with realtime visibility." },
  { label: "Sales Reps", icon: BadgePercent, description: "Grow accounts and track referral revenue." },
  { label: "Emergency Services", icon: AlertTriangle, description: "Report and track help for your drivers fast using AI." },
];

const BrandingGraphic = ({
  className = "",
  compact = false,
  title = "THE EAGLE",
  description = "Your logistics command center for seamless supply chain operations.",
}) => {
  const wrapperClassName = compact
    ? "relative overflow-hidden rounded-3xl border border-white/10 bg-card shadow-card"
    : "relative h-full overflow-hidden";

  return (
    <div className={`${wrapperClassName} ${className}`.trim()}>
      <img
        src="/assets/the-eagle-lading-bg.png"
        alt="The Eagle branding graphic"
        className="absolute inset-0 h-full w-full object-cover"
      />
      <div className="absolute inset-0 bg-black/65" />
      <div className="grid-background absolute inset-0 opacity-25" />

      <div className={`relative z-10 flex h-full flex-col ${compact ? "justify-between gap-6 p-5 sm:p-6" : "justify-between p-12"}`}>
        <div className="space-y-4">
          <div className="flex items-center gap-3">
            <img
              src="/assets/eagle-favco.png"
              alt="The Eagle logo"
              className={`${compact ? "h-11 w-11" : "h-12 w-12"} rounded-lg object-cover border border-white/20`}
            />
            <span className={`${compact ? "text-2xl" : "text-3xl"} font-heading font-bold tracking-tight`}>{title}</span>
          </div>
          <p className={`${compact ? "max-w-lg text-sm text-stone-200 sm:text-base" : "max-w-md text-lg text-stone-200"}`}>
            {description}
          </p>
        </div>

        <div className={`grid gap-3 ${compact ? "sm:grid-cols-2" : "max-w-xl"}`}>
          {featureItems.map(({ label, icon: Icon, description: itemDescription }) => (
            <div key={label} className="rounded-2xl border border-white/10 bg-black/30 p-3 backdrop-blur-sm">
              <div className="flex items-center gap-2 text-sm font-semibold text-white">
                <Icon className="h-4 w-4 text-orange-300" />
                <span>{label}</span>
              </div>
              <p className="mt-1 text-xs text-stone-300">{itemDescription}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BrandingGraphic;
